//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import LoadItem from '../common/FlexiItem/FlexiItemLoader';
import FlexiItemTopMenu from '../common/FlexiItem/FlexiItemTopMenu';
import FlexiItemHeader from '../common/FlexiItem/FlexiItemHeader';
import FlexiItemContent from '../common/FlexiItem/FlexiItemContent';

//Unique ID generator
import { v4 as uuidv4 } from 'uuid';

//Contexts
import { AppContext } from "../Auth/contexts/AppContext"

//Redux Features
import { useSelector, useDispatch } from 'react-redux'; //Controls active menu item and others.
import {
	setCurrentMenuSection,
	setCurrentMenuItem
} from '../../features/mainmenu/mainmenuSlice';


//CSS Styles
//import { useTheme } from '@mui/material/styles'; //Only if needed. Access theme variables with: const theme = useTheme(); Add custom properties to theme in ui/theme/index.js.
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers

//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

//Icons for Custom Buttons:
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Select } from '@mui/material';




const PartFlexiItem = ({isChild,	itemid,	viewmode, backlinkurl, backlinktext, SetView, UpdateState}) => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context - Allows userPerms, userRole, and others to be used*/
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;
	const history = useHistory();

	const dispatch = useDispatch();

	/* ##########################  Configuration  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views that child <FlexiGrid> will digest and use, not the perms on data.
	var perms = {
		createPerm: (userPerms['createPart'] === 1 ? true : false),
		readPerm: (userPerms['readPart'] === 1 ? true : false),
		updatePerm: (userPerms['updatePart'] === 1 ? true : false),
		deletePerm: (userPerms['deletePart'] === 1 ? true : false),
		admin:(userRole === "admin" ? true : false)
	}

	//URL Param for ID
	//Check Props before using params. This controller may be called from a parent controller, so the ID may come from there. (such as a grid view)
	let { id } = useParams(); //Get parameter from URL - In table views, the route isn't configured to take an ID, which is OK because we won't need it on child view.
	if (!id && isChild){
		id = itemid;
	}
	console.log("This id: "+id);


	/* ##########################  DATA MUTATION  ########################## */
	// //   This function allows us to mutate data after it is received from the database, but before it is rendered on the grid or exported.
	// const MutateData = (dbdata) => {
	// 	//Mutate each item in dbdata as needed.
	// 	for (var i=0; i<dbdata.length; i++){
	// 		//Example: Add Margin calculation
	// 		dbdata[i]["NewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])).toFixed(2);
	// 	}
	// 	return dbdata;
	// }
	// //An example of mutation specifically for exports. This allows you to have different data shown on screen vs exported.
	// const ExportMutateData = (dbdata) => {
	// 	//Mutate each item in dbdata as needed.
	// 	for (var i=0; i<dbdata.length; i++){
	// 		//Example: Add Margin calculation
	// 		dbdata[i]["NewNewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])+500).toFixed(2);
	// 	}
	// 	return dbdata;
	// }



	/* ##########################  CUSTOM FUNCTIONS  ########################## */
	const CalculateMargin = ({localstate}) =>{
		localstate.itemdata.Margin = (parseFloat(localstate.itemdata.Price) - parseFloat(localstate.itemdata.Cost)).toFixed(2);
	}


	

	//Configuration
	const configuration = {

		//Menu Setup
		menuitem: "/parts",
		menusection: "Martin's Section",
		title: "Part", //Tab Title
		//HeaderConstruction
		headerprepend:"Part: ", //string or null
		headervalue: 'Name', //db key for value you want to get or null.
		headerappend:"", //string or null

		//Page Options
		maxwidth:"1200px",
		defaulteditmode: true, //Is the page immediatley


		//Data Options
		fetchapiendpoint: "/flexiitem/getitem", //  'flexiitem/' or custom endpoint
		updateapiendpoint: "/flexiitem/update",
		dbmodel: "flexpart", //or flexproduct, flexorder, etc	
		dbkey: "PartID", //Used as db key for Reading, Updating, Deleting
		dbkeyvalue: id,
		nestedrelationships: [
			'creationuser', //CreatedByUserID
			'updateuser',	//UpdatedByUserID
			'deletionuser', //DeletedByUserID
			//'product'
		],
		childitemurl: "/part/", //When calling SetView or clicking 'ADD ITEM' button, goes to this url with the ID of created item. This exists to be able to make one item after the other if we choose.
		parentitemurl: "/parts/", //When calling SetView from the child, this helps link us back to the appropriate grid. Or when we delete something!
		shortposttimeout: 20000, //Posts don't really need to be short, but they shouldn't be really long either. Let's set a short post to 20 seconds just in case the server gets busy. 20000
		longposttimeout: 60000,
		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport: true,
		creationusersupport: true,
		updateusersupport: true,
		deleteusersupport: true,
		historysupport: false, //THIS IS A PART OF NEW FLEXRECORDDELTAS

		//Perms - So we're just assuming anything could happen in a browser. Any permvalue could be sent to a controller, any data, even validaton broken. Let server-side perms sort that out by dbmodel. Either the user can or can't.
		//So let's just establish perms in configuration.<permtype> and go with it!
		createPerm: (userPerms['createPart'] === 1 ? true : false),
		readPerm: (userPerms['readPart'] === 1 ? true : false),
		updatePerm: (userPerms['updatePart'] === 1 ? true : false),
		deletePerm: (userPerms['deletePart'] === 1 ? true : false),



		//Mutations: 
		//    Useful for derived values that are usually rendered, but not for edits. Things such as FullName or TotalCharges which might change based on a change of a nested value.
		//    They are calculated client-side after data load and can be used for view. This helps keep our data loader clean of custom logic.
		//    Assign a Fn or null.

		// mutatedata:MutateData,
		// exportmutatedata:ExportMutateData,
		mutatedata:null,
		exportmutatedata:null,


		//Datetimes to handle server-side. Loader will 
		datetimes: [
			//'DateTime',
			'created_at',
			'updated_at',
		],

		//Float values look nicer when parsed
		floats: [
			'AvgCost',
			'TotalCost'
		],


		/* ##########################  Page Configuration  ########################## */

		topmenubar:{
			render:true,
			backbutton:{
				render:true, //Back behavior will depend on 
				nonchildlinkurl:"/parts",
				nonchildlinktext:"Go to Parts Table"
			},
			savebutton:{
				render:true,
				text:"Save Changes", //Save space by making shorter
			},
			printbutton:{
				render:false,
				text: "Print Record",
			},
			deletebutton:{
				render:true,
				text: "Delete Part",
				confirmationtext:"Confirm deletion of part: ", //Customize at your leisure
			},
			statusbar:true,


			custombuttons:[
				// {
				// 	render:true,
				// 	text:"Custom Btn 1",
				// 	icon: <RestartAltIcon sx={{
				// 		color: "#222", fontSize: "1.2em", // match text size
				// 		verticalAlign: "middle", // helps on some browsers
				// 		display: "inline-block",
				// 	}}>
				// 	</RestartAltIcon>,
				// }
			]
		},

		//Fields and validation, together at last.
		contentelements:[
			{
				rendertype:"section",
				title: "Part Details",
				description: null,
				//Sections should always have children
				children:[
					{
						rendertype:"gridcontainer",
						children:[
							{
								rendertype:"griditem",
								size:{
									xs:12,
									sm:12,
									md:6,
									lg:6
								},
								children:[
									//KV types are "Key Value" types where we commonly setup a left side label and a right side input. 
									{
										rendertype:"kvstaticinputtext",
										dbfield:"PartID",
										label:"Part ID:",
										labelwidth:170,
										labeltextAlign:"right",
										valuetextAlign:"left",
									},
									{
										rendertype:"kvinputtext",
										dbfield:"Name",
										label:"Name:",
										labelwidth:170,
										labeltextAlign:"right",
										valuetextAlign:"left",
										validation:{
											type:"text",
											maxlength:"10",
											minlength:"1"
										}
									},
									{
										rendertype:"kvstaticinputtext",
										dbfield:"AvgUnitCost",
										label:"Avg Unit Cost:",
										labelwidth:170,
										labeltextAlign:"right",
										valuetextAlign:"left",
										step:"0.01",
										validation:{
											type:"number",
											min:0,
											max:1000000000000
										},
									},
									{
										rendertype:"kvstaticinputtext",
										dbfield:"TotalCost",
										label:"Total Cost:",
										labelwidth:170,
										labeltextAlign:"right",
										valuetextAlign:"left",
										step:"0.01",
										validation:{
											type:"number",
											min:0,
											max:1000000000000
										},
									},
									// {
									// 	rendertype:"kvinputnumber",
									// 	dbfield:"Cost",
									// 	label:"Cost:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// 	step:"0.01",
									// 	validation:{
									// 		type:"number",
									// 		min:0,
									// 		max:1000000000000
									// 	},
									// 	postChangeHander:CalculateMargin
									// },
									// {
									// 	rendertype:"kvinputnumber",
									// 	dbfield:"Price",
									// 	label:"Price:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// 	step:"0.01",
									// 	validation:{
									// 		type:"number",
									// 		min:0,
									// 		max:1000000000000
									// 	},
									// 	postChangeHander:CalculateMargin
									// },
									// {
									// 	rendertype:"kvstaticinputtext",
									// 	dbfield:"Margin",
									// 	label:"Margin:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// 	step:"0.01",
									// 	validation:{
									// 		type:"number",
									// 		min:0,
									// 		max:1000000000000
									// 	}
									// },
									// {
									// 	rendertype:"kvinputnumber",
									// 	dbfield:"PositiveInteger",
									// 	label:"Positive Integer:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// 	step:"1",
									// 	validation:{
									// 		type:"number",
									// 		min:0,
									// 		max:1000000000000
									// 	},
									// },
									// //DateTime
									// {
									// 	rendertype:"kvstaticdatetime",
									// 	dbfield:"DateTime",
									// 	label:"Static DateTime:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvinputdatetime",
									// 	dbfield:"DateTime",
									// 	label:"DateTime Picker:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// //Date
									// {
									// 	rendertype:"kvstaticdate",
									// 	dbfield:"Date",
									// 	label:"Static Date:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvinputdate",
									// 	dbfield:"Date",
									// 	label:"Date Picker:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// //Creation Date
									// {
									// 	rendertype:"kvstaticdatetime",
									// 	dbfield:"created_at",
									// 	label:"Creation Date:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// //Creation User
									// {
									// 	rendertype:"kvcreationuser",
									// 	dbfield:"creationuser",
									// 	label:"Created By:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvstaticdatetime",
									// 	dbfield:"updated_at",
									// 	label:"Update Date:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvupdateuser",
									// 	dbfield:"updateuser",
									// 	label:"Updated By:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvproductbyid", //We don't store Product Name inside records. We store the Product ID. The input shows the product name from the relationship, but a function updates the ProductID.
									// 	dbfield:"product",
									// 	label:"Product:",
									// 	labelwidth:170,
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// },
									// {
									// 	rendertype:"kvinputtextarea",
									// 	dbfield:"Notes",
									// 	label:"Notes:",
									// 	labelwidth:170,
									// 	height:"45px",
									// 	labeltextAlign:"right",
									// 	valuetextAlign:"left",
									// 	backgroundColor:"#EEE",
									// },

								]
							},
							{
								rendertype:"griditem",
								size:{
									xs:12,
									sm:12,
									md:6,
									lg:6
								},
								children:[
									//Second Column
									{
										rendertype:"kvinputcheckbox",
										dbfield:"Active",
										label:"Active:",
										labelwidth:170,
										labeltextAlign:"right",
										valuetextAlign:"left",
										validation:{
											type:"boolean"
										}
									}									
								]
							}
						]
					}
				]
			}
		]
	}


	/* ##########################  UseState Variables  ########################## */
	const [state, setState] = useState({
		dbreload: true,
		reloadparenttable: false, //New! So we need to change this every time we successfully save a record. 
		itemloaded: false,
		pendingupdate: false,
		editmode: configuration.defaulteditmode,
		deleteitem:false,
		auditview: false,
		historyavailable: (configuration.historysupport && configuration.auditPerm),
		itemdata: {

		},
		deleteitem:false //Used in SaveChanges
	});
	//Clone State! We'll get the view from localstate!
	let localstate = Object.assign({}, state);
	function UpdateState(stateobject) {
		setState(stateobject);
	}


	useEffect(() => {
		//To Do: On load of item, set title to the serial number.
		document.title = "Part";
		dispatch(setCurrentMenuSection(configuration.menusection));
		dispatch(setCurrentMenuItem(configuration.menuitem));
		if (state.dbreload) {
			//Avoid duplicate loads.
			localstate.dbreload = false;
			//Diagnostic:
			console.log("Localstate ID: " + id);
			LoadItem(localstate, UpdateState, configuration, dispatch);
		}
	}, [state]);


	return (
		<div style={{backgroundColor:"#EEE", borderLeft:"1px solid #AAA", minHeight:"calc(100vh - 35px)"}}>
			<FlexiItemTopMenu 
				localstate={localstate}
				UpdateState={UpdateState}
				classes={classes}
				configuration={configuration}
				SetView={SetView}
				isChild={isChild}
				backlinktext={backlinktext}
				dispatch={dispatch}
				history={history}
				perms={perms}
			/>
			<div key="itemcontainer" style={{
				margin:"auto", 
				maxWidth:configuration.maxwidth,
				textAlign:"center",
				fontFamily:"Inter",
				fontOpticalSizing:"auto",
				fontWeight:350,
				
				}}>
					{(localstate.itemloaded) &&
					<>
					<FlexiItemHeader headerprepend={configuration.headerprepend} headerappend={configuration.headerappend} headervalue={configuration.headervalue} localstate={localstate} />
					<FlexiItemContent configuration={configuration} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} dispatch={dispatch} />
					</>
						
					}
			</div>
		</div>
	);
}
export default PartFlexiItem;